export default __webpack_public_path__ + "static/media/Logo_latest.574f147f.png";